<template>
  	<div class="animated fadeIn">
		<b-row>
		    <b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
					<div slot="header">
						<i class="fa fa-align-justify"></i><strong> {{$trans['general']['nav_sources']}}</strong>
					</div>
					<b-list-group>
						<b-list-group-item v-for="(item, idx) in sources_sorted" :key="idx" class="p-2">
							<b-row>
								<b-col md="5" lg="3" class="d-none d-md-inline-block" v-html="(item.has_trans) ? $trans['general'][item.name] : item.name">
									
								</b-col>
								<b-col md="7" lg="9" cols="12">
									 <a :href="item.url" target="_blank">{{item.url}}</a>
								</b-col>
							</b-row>
						</b-list-group-item>
					</b-list-group>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>

export default {
	data() {
		return {
			sources: [
				{
					name: 'INE',
					url: 'https://www.ine.pt'
				},
				{
					name: 'PORDATA',
					url: 'https://www.pordata.pt'
				},
				{
					name: 'CTT',
					url: 'https://www.ctt.pt'
				},
				{
					has_trans: true,
					name: 'nav_fire_departments',
					url: 'https://www.bombeiros.pt'
				},
				{
					name: 'GNR',
					url: 'https://www.gnr.pt'
				},
				{
					name: 'PSP',
					url: 'https://www.psp.pt'
				},
				{
					name: 'Continente',
					url: 'https://www.continente.pt'
				},
				{
					name: 'Pingo Doce',
					url: 'https://www.pingodoce.pt'
				},
				{
					name: 'Wikipedia',
					url: 'https://pt.wikipedia.org'
				},
				{
					name: 'OpenStreetMap',
					url: 'https://nominatim.openstreetmap.org'
				},
				{
					name: 'Google Geocoding API',
					url: 'https://developers.google.com/maps/documentation/geocoding/overview'
				},
				{
					name: 'OpenWeatherMap',
					url: 'https://openweathermap.org'
				},
				{
					name: 'Central de Dados',
					url: 'http://centraldedados.pt'
				}
			]
		}
	},
	computed: {
		sources_sorted: function() {
			return this.sources.sort((a, b) => a.name.localeCompare(b.name));
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>